import { Etapas, TiposEstructura } from './enums/enums';

export const config = {
    [Etapas.ETAPA_0]: {
        [TiposEstructura.APRENDIZAJE_BASADO_EN_PROYECTOS]: ["Titulo", "Problematica", "Pregunta_Guia", "Producto_Final", "Nivel", "Objetivos", "Tipo", "Estructura", "Beneficiario", "Story_Telling", "Conceptos_Clave", "Aprendizajes_Esperados", "Lanzamiento", "Evaluacion", "Indagacion", "Beneficio_Exhibicion", "Creacion"],
        [TiposEstructura.UNIDAD_ACTIVA]: ["plan_academico", "temas"],
    },
    [Etapas.ETAPA_1]: {
        [TiposEstructura.APRENDIZAJE_BASADO_EN_PROYECTOS]: ["Lanzamiento", "Indagacion", "Creacion", "Beneficiario_Exhibicion", "Evaluacion"],       
    },    
};
